import { Chip, ChipProps } from "@mui/material";
import React from "react";

interface MicroChipProps extends Omit<ChipProps, 'sx'> {
  sx?: ChipProps['sx'];
}

const MicroChip: React.FC<MicroChipProps> = ({ sx, ...props }) => {
  const defaultSx = {
    height: "24px",
    justifyContent: "center",
    fontSize: "0.75rem"
  };

  const combinedSx = Array.isArray(sx)
    ? [defaultSx, ...sx]
    : { ...defaultSx, ...sx };

  return <Chip sx={combinedSx} {...props} />;
};

export default MicroChip;